import * as React from 'react';
export const DisplayModeContext = /*#__PURE__*/React.createContext({
  mode: 'AM',
  setMode: () => {}
});
//# sourceMappingURL=DisplayModeContext.js.map